import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { showToast } from "../../Components/utils/ShowToast";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Loader from '../../Components/utils/Loader';

function AdminTerms() {
    const [terms, setTerms] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/terms`)
            .then(res => {
                if (res.data.success) {
                    setTerms(res.data?.terms || "");
                }
            }).finally(() => setIsLoading(false));
    }, []);

    const handleSave = () => {
        const token = localStorage.getItem('adminToken');
        setIsLoading(true);
        axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/terms`, { content: terms }, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(res => {
                if (res.data.success) {
                    showToast('Terms & conditions updated successfully!', "success");
                }
            })
            .catch(e => {
                showToast(e?.response?.data?.error || "Something went wrong!", "error");
            }).finally(() => setIsLoading(false));
    };

    return (
        <div className='adminTermsDiv'>
            {isLoading && <Loader type="checkmate" />}
            <div className="adminTermsContent">
                <div className="form">
                    <h2 className='secondaryHeading'><span>Terms</span> & <span>Conditions</span></h2>
                    <div className="horizontalLine"></div>
                    <ReactQuill
                        value={terms}
                        onChange={(value) => setTerms(value)}
                        theme="snow"
                        className='reactQuill'
                    />
                    <button className='primaryBtn' onClick={handleSave} disabled={isLoading}>Save</button>
                </div>
            </div>
        </div>
    );
}

export default AdminTerms;
